if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.setupZoom();
      }

      hide() {
        super.hide();
        this.resetZoom();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.resetZoom();
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      get zoomContainer() {
        return this.querySelector('[role="document"]');
      }

      resetZoom() {
        const container = this.zoomContainer;
        if (container) container.classList.remove('is-zoomed', 'is-panning');
      }

      /* Click the contained image to zoom to 200%, then drag (desktop) or
         touch-scroll (mobile) to move around it. Click again to zoom out. */
      setupZoom() {
        const container = this.zoomContainer;
        if (!container) return;

        let pointerDown = false;
        let dragged = false;
        let startX = 0;
        let startY = 0;
        let startScrollLeft = 0;
        let startScrollTop = 0;

        // Native image dragging would fight the pan gesture.
        container.addEventListener('dragstart', (event) => event.preventDefault());

        container.addEventListener('click', (event) => {
          const image = event.target.closest('img.active');
          if (!image || dragged) return;

          if (container.classList.contains('is-zoomed')) {
            container.classList.remove('is-zoomed');
            return;
          }

          // Zoom in centred on the point that was clicked.
          const rect = container.getBoundingClientRect();
          const fractionX = (event.clientX - rect.left) / rect.width;
          const fractionY = (event.clientY - rect.top) / rect.height;
          container.classList.add('is-zoomed');
          container.scrollLeft = container.scrollWidth * fractionX - rect.width / 2;
          container.scrollTop = container.scrollHeight * fractionY - rect.height / 2;
        });

        container.addEventListener('pointerdown', (event) => {
          if (!container.classList.contains('is-zoomed') || event.pointerType !== 'mouse') return;
          pointerDown = true;
          dragged = false;
          startX = event.clientX;
          startY = event.clientY;
          startScrollLeft = container.scrollLeft;
          startScrollTop = container.scrollTop;
          container.classList.add('is-panning');
        });

        container.addEventListener('pointermove', (event) => {
          if (!pointerDown) return;
          const deltaX = event.clientX - startX;
          const deltaY = event.clientY - startY;
          if (Math.abs(deltaX) > 4 || Math.abs(deltaY) > 4) dragged = true;
          container.scrollLeft = startScrollLeft - deltaX;
          container.scrollTop = startScrollTop - deltaY;
        });

        const endPan = () => {
          pointerDown = false;
          container.classList.remove('is-panning');
          // Let the click handler read `dragged` before clearing it.
          setTimeout(() => (dragged = false));
        };
        container.addEventListener('pointerup', endPan);
        container.addEventListener('pointercancel', endPan);
      }
    }
  );
}
